module.exports = __webpack_public_path__ + "static/img/contentRightImg3.b1a1193.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contentRightImg3.png
// module id = oSHF
// module chunks = 2